import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';

import { PrimarySolidButton, SecondaryTextButton } from '@bibliocommons/base-buttons';

import './ModalFooter.scss';

function close() {
  window.history.back();
}

export default function ModalFooter({
  className,
  disabled,
  isLoading,
  stacked,
  primaryActionButtonTag,
  primaryActionButtonText,
  secondaryActionButtonTag,
  secondaryActionButtonText,
  handlePrimaryAction,
  handleSecondaryAction,
  renderPrimaryAction,
  renderSecondaryAction
}) {
  const PrimaryActionButtonTag = primaryActionButtonTag || PrimarySolidButton;
  const primaryButton = renderPrimaryAction ? (
    renderPrimaryAction()
  ) : (
    <PrimaryActionButtonTag
      className="modal-footer__primary-button"
      dataKey="modal-primary-button"
      disabled={disabled}
      isLoading={isLoading}
      handleClick={handlePrimaryAction}
    >
      {primaryActionButtonText}
    </PrimaryActionButtonTag>
  );

  const SecondaryActionButtonTag = secondaryActionButtonTag || SecondaryTextButton;
  const secondaryButton = renderSecondaryAction ? (
    renderSecondaryAction()
  ) : (
    <SecondaryActionButtonTag
      className="modal-footer__secondary-button"
      dataKey="modal-secondary-button"
      handleClick={handleSecondaryAction || close}
      type="button"
    >
      {secondaryActionButtonText || <FormattedMessage id="button_cancel" />}
    </SecondaryActionButtonTag>
  );

  const classNames = cn('cp-modal-footer', className, {
    'modal-footer--stacked': stacked
  });

  return (
    <footer className={classNames}>
      {stacked ? primaryButton : secondaryButton}
      {stacked ? secondaryButton : primaryButton}
    </footer>
  );
}

ModalFooter.propTypes = {
  className: PropTypes.string,
  primaryActionButtonTag: PropTypes.elementType,
  primaryActionButtonText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  secondaryActionButtonTag: PropTypes.elementType,
  secondaryActionButtonText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  handlePrimaryAction: PropTypes.func,
  // Defaults to going back, which is how a modal that owns a history entry closes itself. Pass this
  // when the modal does not own one -- see Modal's skipHistoryEntry -- or Cancel presses Back for
  // real.
  handleSecondaryAction: PropTypes.func,
  renderPrimaryAction: PropTypes.func,
  renderSecondaryAction: PropTypes.func,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  stacked: PropTypes.bool
};
